export default __webpack_public_path__ + "static/media/icon6.e991b979.svg";